import { firstDayOfMonth, type SimpleDate, simplyToday } from '../utils/SimpleDate';
import { useLocation, useParams } from 'react-router-dom';
import { useQuery } from 'react-query';
import { getWarning } from '../restapi/warningEvent';


export function usePreviewMonth(): SimpleDate {
	const {month} = useParams<{ month: SimpleDate }>();
	return month || firstDayOfMonth(simplyToday());
}

export function usePreviewTypeIsDoc() {
	const location = useLocation();
	return location.pathname.includes('doc-preview');
}

export function useWarningId() {
	const {id} = useParams<{ id: string }>();
	return parseInt(id || '0');
}

export function useWarning() {
	const id = useWarningId();
	const q = useQuery(['warning', id], () => getWarning(id), {
		enabled: !!id,  // load only if there is a valid id
	});
	return q.data;
}
